import { STATICS } from 'api/api'
import { Icon }                    from 'assets/Icons_'
import { Footer, Inner } from './NoAvailableUnit.Portal.style'
import { useBreak } from 'hooks/useBreak';
import { useTranslation } from 'react-i18next';
import { Box, FormControl, Grid } from '@mui/material';
import { CustomLabel } from 'components/Contact/styled-components';
import { CustomPlaceHolderInputField } from 'components/FormComponent/TextField';
import { useForm } from 'react-hook-form';
import { active_project } from 'state/store.global';
import { getFocus, useGet } from 'state/jotai';
import { _project } from 'state/store.projects';
import { PhoneNumberDropdown } from 'components/AdvanceDropdown/PhoneNumberDropdown/Dropdown';
import { CustomButton } from 'components/Unit/NewReservationButton';
import { ReactSelect } from 'components/AdvanceDropdown/NormalDropdown/Dropdown';

export const NoAvailableUnitForm = ({ click, size, wrap, color, icon, setAvailableUnit, setStep }) => {
    const { i18n:{language} }             = useTranslation()
    const isMobile                        = useBreak("md_dn");
    const close   = { icon, color, wrap, size, click }

    const { register, handleSubmit, control, reset, formState: { errors, isValid } } = useForm({ mode: 'onChange' });

    const { pin, pid } = useGet(active_project) 
    const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

    return  <>
        <img       src      = {`${STATICS}/svg/no-available-unit-image-2.svg`} alt = ''  style = {{ height : isMobile ? "150px" : "250px", objectFit: "contain", borderRadius:"6px", marginTop: "24px" }} />
            <Icon {...close} />
            <Inner>
                <div    className = 'h3'>{ form1Translation['heading'][language] }</div>
                <div    className = 'paragraph1-regular'>{ form1Translation['paragraph1'][language] }</div>
                <div    className = 'paragraph1-regular'>{ form1Translation['paragraph2'][language] }</div>
              </Inner>

            
              <form style={{ padding: "0 24px 0px 24px", height: isMobile ? "230px" : "100%" }}>
                <Grid
                    container
                    columnSpacing={3}
                    rowSpacing={1}
                    sx={{ mb: 3 }}
                >
                    <Grid item xs={12}>
                    <Grid sx={{ gap: "16px" }}>
                    <FormControl
                        sx={{ mb: 2, gap: '8px' }}
                        fullWidth
                        variant='filled'
                    >
                        <CustomLabel shrink  className="h5">
                        {form1Translation['fullName'][language]}&nbsp;<span>*</span>
                        </CustomLabel>
                        <CustomPlaceHolderInputField
                        error={errors.firstname ? true : false}
                        helperText={form1Translation['full&MiddleName'][language]}
                        // label= { buttonsLabel?.filter( btn => btn.UILabelProperty === 'FirstMiddleName')[0]?.Label }
                        label={form1Translation['full&MiddleName'][language]}
                        register={{...register('firstname', { required: true, validate: value => value.trim() !== "" })}}
                        />
                    </FormControl>
                    <FormControl fullWidth variant='filled'>
                        <CustomPlaceHolderInputField 
                        helperText={form1Translation['lastName'][language]}
                        error={errors.lastname ? true : false}
                        label={form1Translation['lastName'][language]}
                        register={{...register('lastname', { required: true, validate: value => value.trim() !== "" })}}
                        />
                    </FormControl>
                    </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sx={{ pt: "0 !important" }}>
                <Grid sx={{ pt: "0 !important" }}>
                  <FormControl
                    sx={{ mb: '24px', gap: '8px' }}
                    fullWidth
                    variant='filled'
                  >
                    <CustomLabel shrink  className="h5">
                    {form1Translation['fullName'][language]}&nbsp;<span>*</span>
                    </CustomLabel>
                    <CustomPlaceHolderInputField
                      error={errors.email ? true : false}
                      helperText={buttonsLabel?.filter( btn => btn.UILabelProperty === 'emailAddressErrorWarn')[0]?.Label}
                      label={buttonsLabel?.filter( btn => btn.UILabelProperty === 'FormularEmail')[0]?.Label}
                      register={{...register('email', { required: true,  validate: (value) => {
                        const trimmedValue = value.trim();  // Trim spaces before and after the email
                        if (!trimmedValue) {
                          return false
                        }
                        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (!emailPattern.test(trimmedValue)) {
                          return false
                        }
                        return true;
                      } })}}
                    />
                  </FormControl>
                </Grid>
                </Grid>
                <Grid item xs={12} sx={{ pt: "0 !important" }}>
                <Grid sx={{ gap: "16px" }}>
                  <FormControl
                    sx={{ mb: 3, gap: '8px' }}
                    fullWidth
                    variant='filled'
                  >
                    <CustomLabel shrink  className="h5">
                    {form1Translation['privateEmail'][language]}&nbsp;<span>*</span>
                    </CustomLabel>
                    <PhoneNumberDropdown error={errors.country_id || errors.phone ? true : false} helperText={'country'} options={[]} control={control} getPhoneId={'country_id'} getPhoneNumber={'phone'} placeholder={ form1Translation['country'][language] } description={buttonsLabel?.filter( btn => btn.UILabelProperty === 'CountryCodeDropdownDescription')[0]?.Label} />
                  </FormControl>
                </Grid>
                <Grid sx={{ gap: "16px" }}>
                  <FormControl
                    sx={{ mb: 3, gap: '8px' }}
                    fullWidth
                    variant='filled'
                  >
                    <CustomLabel shrink  className="h5">
                    {form1Translation['unitInformation'][language]}&nbsp;<span>*</span>
                    </CustomLabel>
                    <Box sx={{ display: 'flex', gap: "16px" }}>
                        <ReactSelect sx={{ width: '150px'}} placeholder={form1Translation['maxRent'][language]} />
                        <ReactSelect sx={{ width: '150px'}} placeholder={form1Translation['MinnoOfRoomN'][language]} />
                        <ReactSelect sx={{ width: '150px'}} placeholder={form1Translation['MinSqm'][language]} />
                    </Box>
                  </FormControl>
                </Grid>
                </Grid>
                <Footer style={{ padding: "0 0 16px 0"}}>
                    <CustomButton
                    padding = {'12px 24px'}
                    variant = { "secondary" }
                    onClick = {() => setAvailableUnit(false)}
                    clr = {f_clr}
                  >
                    <span className = "eus-button-2">
                      { form1Translation['button1'][language] }
                    </span>
                    </CustomButton>
                    <CustomButton
                        padding = {'12px 24px'}
                        variant = { "primary" }
                        onClick = {() => setStep(3)}
                        clr = {f_clr}
                    >
                        <span className = "eus-button-2">
                        { form1Translation['button2'][language] }
                        </span>
                    </CustomButton>
                </Footer>
              </form>
    </>
}

const form1Translation = {
    'heading': {
      'en': 'Sign up for matching',
      'da': 'Tilmeld dig matching'
    },
    'paragraph1': {
      'en': 'Fill in your information below to create a matching profile. Please also add information about your requirements for your new unit.',
      'da': 'Udfyld dine oplysninger nedenfor for at oprette en matchende profil. Tilføj også oplysninger om dine krav til din nye enhed.'
    },
    'paragraph2': {
      'en': 'When a unit that matches your needs become available you will get notified on email.',
      'da': 'Når en enhed, der matcher dine behov bliver tilgængelig, får du besked på e-mail.'
    },
    'paragraph3': {
      'en': 'Sign up to create a matching profile. When a unit that matches your needs become available you will get notified on email.',
      'da': 'Tilmeld dig for at oprette en matchende profil. Når en enhed, der matcher dine behov bliver tilgængelig, får du besked på e-mail.'
    },
    'button1': {
      'en': 'Close',
      'da': 'Tæt'
    },
    'button2': {
      'en': 'Sign up for matching',
      'da': 'Tilmeld dig matching'
    },
    "fullName": {
        'en': "Full name",
        'da': "Fulde navn"
    },
    "full&MiddleName": {
        'en': "First name and middle name",
        'da': "Fornavn og mellemnavn"
    },
    "lastName": {
        'en': "Last name",
        'da': "Efternavn"
    },
    "privateEmail": {
        'en': "Private email",
        'da': "Privat email"
    },
    "email": {
        'en': "email",
        'da': "email"
    },
    "PhoneNumber": {
        'en': "Phone number",
        'da': "Telefonnummer"
    },
    "country": {
        'en': "Country",
        'da': "Land"
    },
    "phone": {
        'en': "Phone",
        'da': "Telefon"
    },
    "unitInformation": {
        'en': "Unit information",
        'da': "Enhedsoplysninger"
    },
    "maxRent": {
        'en': "Max rent",
        'da': "Max husleje"
    },
    "MinnoOfRoomN": {
        'en': "Min. no. of rooms",
        'da': "Min. ingen. af værelser"
    },
    "MinSqm": {
        'en': "Min. sqm",
        'da': "Min. kvm"
    }
  }